import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAppointmentRequestComponent } from './components/customer-appointment-request/customer-appointment-request.component';
import { GoogleAppointmentRequestComponent } from './components/google-appointment-request/google-appointment-request.component';
import { PrivacyPolicyTemplateComponent } from './components/privacy-policy-template/privacy-policy-template.component';

const routes: Routes = [
  {
    path: ':appt_conf_token',
    component: CustomerAppointmentRequestComponent,
    data: {
      id: 'customer-appointment-request',
    },
  },
  {
    path: 'google/:appt_conf_token',
    component: GoogleAppointmentRequestComponent,
    data: {
      id: 'customer-appointment-request',
    },
  },
  {
    path: 'privacy-policy/:appt_conf_token',
    component: PrivacyPolicyTemplateComponent,
    data: {
      id: 'privacy-policy-template',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAppointMentRequestRoutingModule {}
